<template>
    <div class="page">
        <strong>Date:</strong> {{ userStore.user.tdate }}
        <br />
        <br />
        <p>
            {{ creditBureau.address_name }} <br />
            {{ creditBureau.street_address }} <br />
            {{ creditBureau.city }}, {{ creditBureau.state_abbrev }}
            {{ creditBureau.zipcode }}
        </p>
        <p>
            <template v-if="creditBureau.officers">
                <strong>Attn:</strong> {{ creditBureau.officers }} <br />
                <!-- <strong>TO:</strong> {{ creditBureau.name }} and {{creditBureau.officers}} -->
            </template>
        </p>
        <!-- <p>
            <strong>In The Matter Of:</strong> Initial Dispute Investigation
        </p> -->
        <p class="letter-content">
            This letter is to inform you that you have reported and published incomplete and inaccurate information (“tradeline(s)”)
            about me in your consumer reports. Your conduct has caused me financial harm, including out-of-pocket costs and lost opportunities.
        </p>
        <p>
            The following account you are publishing about me is [“inaccurate” or “incomplete” or “inaccurate and incomplete”]
        </p>
        <p>
            <template v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
                <strong>NAME OF ACCOUNT:</strong> {{ creditor.furnisher_name }}
                <br/>
                <template v-if="creditor.reference_number">
                    <strong>REFERENCE NUMBER: </strong>{{ creditor.reference_number }}
                    <br/>
                </template>
                <template v-else>
                    <strong>ACCOUNT NUMBER: </strong>{{ creditor.account_number }}
                    <br/>
                </template>
                <br/>
            </template>
        </p>
        <p>
            I request that you <strong><u>DELETE</u></strong> the above-listed tradeline and provide me an updated consumer report. Please inform any person
            or entity to whom you have reported this information that it has been deleted from my report.
        </p>
        <p class="letter-content">
            If you determine that the tradeline item is verified, please provide details of your verification method. Specifically,
            please describe the procedure used to verify the accuracy and completeness of such information. I also request a copy of
            all documents created by you or anyone else in connection with your processing of this tradeline item;
            the person’s name, address, and telephone number of such furnisher when you initially prepared that report.
        </p>
        <p class="letter-content">
            You are not in compliance with the Fair Credit Reporting Act because you do not have reasonable procedures in place to
            assure maximum accuracy and completeness of the information that you include in your consumer reports concerning me.
        </p>
        <p class="letter-content">
            Credit reporting agencies are required by federal law to obtain a consumer's consent before publishing information in
            their consumer files. I request that you contact me to review credit information about me before you publish it. I also
            do not consent to you making money from the use of my name.
        </p>
        <p>
            Enclosed are copies of ID and proof of mailing address.
        </p>
        <p style="page-break-after: always;">
            Thank you for your time, <br> <br>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}<br />
            {{ userStore.user.dob }}<br />
            {{ userStore.user.ssn }}<br />
            {{ userStore.user.address }}<br />
            {{ userStore.user.city }}, {{ userStore.user.state }}
        </p>
    </div>
    <div class="page-content">
        <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
        <p style="padding-top:3rem; text-align: center;">
            <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
            <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
        </p>
        <p v-if='userStore.user.address_verify_image_url'>
            <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore()
            };
        }
    };
</script>
